import React, { useState } from 'react';
import axios from 'axios';
import { PARTNER_ID, PARTNER_ID_KEY, PAYMENT_STEPS } from '../constant';
const useExtraFunctions = () => {

      // regex for mobile number
       const regexMobileNumber = /^[0-9]{10}$/;
      //const regexMobileNumber = /^\\+91[6789]\\d{9}$/;
      //const mobileRegex = /^\+?[0-9]{1,4}?[0-9]{10}$/; +91 must be there
      //const indianMobileRegex = /^(\+91[\s]?)?[6789]\d{9}$/;
      //const internationalMobileRegex = /^\+?[1-9]\d{1,14}$/;


      //UPI regx
      const upiRegex = /^[\w.\-]{2,256}@[a-zA-Z]{2,64}$/;

      //bank account number regex
      const regexBankAccountNumber = /^[0-9]{8,20}$/;




      const validateMobile = (number: string): boolean => {
        return /^\d+$/.test(number) && regexMobileNumber.test(number);
      };

      const validateUpi = (upi: string): boolean => {
        return upiRegex.test(upi);
      };

      const ValidateBlankField = (field: string): boolean => {
        return field.trim() === '';
      };

      const ValidateTwoField = (field1: string, field2: string): boolean => {
        return field1 === field2;
      };

      const ValidateBankAccountNumber = (field: string): boolean => {
        return regexBankAccountNumber.test(String(field));
      };

      const SendPostAPI = async (url: string, data: any, token: string) => {
        return await axios.post(url, data, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        })
        .then((response) => {
          console.log("here");
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
      };

      const DateCompare = (date1?: Date | null, date2?: Date | null): boolean => {
        if (!date1 || !date2) return false; // Ensure both dates are defined
        return date1.getTime() >= date2.getTime();
    };

    const changeDangerousHTML = (html: any) => {
     return <span
      className="changeDangerousHTML"
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    ></span>
    };

    const changeDangerousHTMLWithoutPreHtml = ({ html, tag: Tag = "div" }: { html: string; tag?: keyof JSX.IntrinsicElements }) => {

      const TagName = Tag || "div";

      return <TagName className="changeDangerousHTML" dangerouslySetInnerHTML={{ __html: `${html}` }} />;
    };

    const getPartnerId = () => {
      const partnerId = localStorage.getItem(PARTNER_ID_KEY) || PARTNER_ID;
      return partnerId;
    }

    const htmlTagMaker = (html: any, style?: any, text?: any, isDangerousHTML?: boolean) => {
      
      const HTMLTag = html || 'span'; // default to h2

      const HtmlInitalFirst = (
        <HTMLTag
          style={style}
        >
          {isDangerousHTML ? changeDangerousHTML(text) : text}
        </HTMLTag>
      );

      return HtmlInitalFirst;
    }

    const initialPaymentMethodAvaliable = (setCurrentStep: any) => {
      
      setCurrentStep((prev: any)=>{
        return prev?.map((step: any) => {
            //console.log("step-cr", currentStep.find((step: any) => step.slug === PAYMENT_STEPS.INITIAL));
            return { ...step, isOpen:  step.slug === PAYMENT_STEPS.INITIAL_PAYMENT_METHOD_AVALIABLE ? true : false };
        });
      });
    }

    const editWithdrawalAmountStep = (setCurrentStep: any) => {
      
      setCurrentStep((prev: any)=>{
        return prev?.map((step: any) => { 
            return { ...step, isOpen:  step.slug === PAYMENT_STEPS.EDIT_WITHDRAWAL_AMOUNT ? true : false };
        });
      });
    }

    const initalFastWithdrawalMethodsAvaliable = (setCurrentStep: any) => {
      setCurrentStep((prev: any)=>{
          return prev?.map((step: any) => {
              return { ...step, isOpen:  step.slug === PAYMENT_STEPS.INITIAL ? true : false };
          });
      });
    }

    const initalConfirmScreenMethodAvaliable = (setCurrentStep: any) => {
      setCurrentStep((prev: any)=>{
        return prev?.map((step: any) => {
            return { ...step, isOpen:  step.slug === PAYMENT_STEPS.INITIAL_PAYMENT_CONFIRM_SCREEN_METHOD_AVALIABLE ? true : false };
        });
    });
    }

    const failedPaymentTranscationProcessingMethod = (setCurrentStep: any) => {
      setCurrentStep((prev: any)=>{
        return prev?.map((step: any) => {
            return { ...step, isOpen:  step.slug === PAYMENT_STEPS.FAILED_PAYMENT_PROCESSING ? true : false };
        });
    });
    }

    const successPaymentTranscationProcessingMethod = (setCurrentStep: any) => {
      setCurrentStep((prev: any)=>{
        return prev?.map((step: any) => {
            return { ...step, isOpen:  step.slug === PAYMENT_STEPS.SUCCESS_PAYMENT_PROCESSING ? true : false };
        });
      });
    }

    const paymentProcessingMethod = (setCurrentStep: any) => {
      setCurrentStep((prev: any)=>{
        return prev?.map((step: any)=>{
          return { ...step, isOpen: step.slug === PAYMENT_STEPS.PAYMENT_PROCESSING ? true : false };
        })
      });
    }

    const confrimPaymentProcessingMethod = (setCurrentStep: any) => {
      setCurrentStep((prev: any)=>{
        return prev?.map((step: any)=>{
          return { ...step, isOpen: step.slug === PAYMENT_STEPS.CONFIRM_PAYMENT_PROCESSING ? true : false };
        })
      });
    }

    const initalWithdrawalCardMethodAvaliable = (setCurrentStep: any) => {
      setCurrentStep((prev: any)=>{
        return prev?.map((step: any)=>{
            return { ...step, isOpen: step.slug === PAYMENT_STEPS.INITIAL_WITHDRAWAL_CARD ? true : false };
        });
    });
    }

    const openUPICardStep = (setCurrentStep: any) => {
      setCurrentStep((prev: any) => {
          return prev.map((step: any) => {
              return { ...step, isOpen: step.slug === PAYMENT_STEPS.IS_OPEN_UPI_CARD ? true : false };
          });
      });
    }

    const openBankAccountStep = (setCurrentStep: any) => {
      setCurrentStep((prev: any) => {
        return prev.map((step: any) => {
            return { ...step, isOpen: step.slug === PAYMENT_STEPS.IS_OPEN_BANK_ACCOUNT ? true : false };
        });
      });
    }

    const removeLeadingZerosRegex = (str: string) => {
      return str.replace(/^0+(?=\d)/, '');
    }


    return {
        validateMobile,
        validateUpi,
        ValidateBlankField,
        ValidateTwoField,
        ValidateBankAccountNumber,
        SendPostAPI,
        DateCompare,
        changeDangerousHTML,
        getPartnerId,
        htmlTagMaker,
        changeDangerousHTMLWithoutPreHtml,
        initialPaymentMethodAvaliable,
        initalFastWithdrawalMethodsAvaliable,
        initalConfirmScreenMethodAvaliable,
        failedPaymentTranscationProcessingMethod,
        successPaymentTranscationProcessingMethod,
        paymentProcessingMethod,
        confrimPaymentProcessingMethod,
        initalWithdrawalCardMethodAvaliable,
        openUPICardStep,
        openBankAccountStep,
        editWithdrawalAmountStep,
        removeLeadingZerosRegex
    }

}

export default useExtraFunctions;